export default __webpack_public_path__ + "static/rec-2005-734ae4477dc96bfadaf3e243f880532e.png";